// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".the-mask-icon[data-v-583307b4]{position:absolute;pointer-events:none;width:1px;height:1px;overflow:hidden}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
